import { TableCell, TableRow, Typography } from "../../components/util";
import { PaginatedResults } from "../../components/content";
import { IUser } from "../../services/admin/admin.service";
import userService from "../../services/user/user.service";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import * as Styled from "./styles.css";

const UsersList = ({ users }: IUsersListProps) => {
  const { search } = useLocation();
  const urlParams: Record<string, any> = useMemo(
    () => queryString.parse(search),
    [search],
  );

  const searchTerm = useMemo(() => {
    return urlParams?.searchTerm ? urlParams?.searchTerm : "";
  }, [urlParams?.searchTerm]);

  const userRow = (usersSlice: IUser[]) => {
    return (
      <>
        {usersSlice.map((user: IUser, i: number) => (
          <TableRow key={`user?.id-${i}`}>
            <TableCell>
              <Styled.Link
                href={`/users/${user?.id}${search || ""}`}
                router
                title={`${user.firstname} ${user.lastname}`}
              >
                <Typography truncate={true}>
                  {user.firstname} {user.lastname}
                </Typography>
              </Styled.Link>
            </TableCell>

            <TableCell>
              <Typography truncate={true}>{user.email}</Typography>
            </TableCell>
            <TableCell>
              <Typography styled={{ text: { case: "sentence" } }}>
                {user?.roles.length > 0 &&
                  CamelCaseToNormalCase(user?.roles[0])}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
      </>
    );
  };

  return (
    <PaginatedResults
      id="users-all"
      searchTerm={searchTerm}
      inputResults={{
        hits: users ? users : [],
        total: users ? users.length : 0,
      }}
      tableColumns={[{ title: "Name" }, { title: "Email" }, { title: "Role" }]}
      service={userService.getAllUsers}
      searchService={userService.getAllUsersBySearchTerm}
      tableRows={userRow}
      missing={{
        icon: "people",
        type: "users",
        message: "This is where we’ll show all of the system's uers.",
      }}
    />
  );
};

interface IUsersListProps {
  users?: IUser[] | null;
}

export default UsersList;

const CamelCaseToNormalCase = (val: string) => {
  return val.replace(/([A-Z])/g, " $1").trim();
};
